// Back to top



// Viewport for display button
const showBtnPoint = 100;
let btn = null;
document.addEventListener("DOMContentLoaded", function (){
	btn = document.querySelector(".shownavbar");
	if(btn){
		window.addEventListener("scroll", showBtn)
		//btn.addEventListener('click', moveToTop);
	}
})


function showBtn(){
	let fun = window.scrollY > showBtnPoint ? 'add' : 'remove';
	btn.classList[fun]('show');
}

/* back to top
document.addEventListener("DOMContentLoaded", function (){
	btn = document.querySelector(".backtotop");
	if(btn){
		window.addEventListener("scroll", showBtn)
		btn.addEventListener('click', moveToTop);
	}
})


function showBtn(){
	let fun = window.scrollY > showBtnPoint ? 'add' : 'remove';
	btn.classList[fun]('show');
}

function moveToTop(top = 0){
	window.scrollTo(0, top);
}
*/